// extracted by mini-css-extract-plugin
export default {"notice":"UDVAppAdvocacyBanner--notice--2cf4e9"};